<template>
  <div style="background: #f6f6f7">
    <pcHeaders></pcHeaders>
    <payorder></payorder>
    <!-- <div id="class1"></div> -->
    <pcBottom></pcBottom>
  </div>
</template>
<script>
// 这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
// 例如：import 《组件名称》 from '《组件路径》';
import pcHeaders from '../component/head.vue';
import payorder from '../car/toPayOrder.vue';

import pcBottom from '../component/bottom.vue';
import $ from 'jquery';
import { toOrderConfirm, getOrderId } from '@/api/pay.js';

export default {
  // import引入的组件需要注入到对象中才能使用
  components: {
    pcHeaders,
    pcBottom,
    payorder
  },
  data() {
    // 这里存放数据
    return {
      calssInfo: {}, //订单核对数据
      paymentNum: 0, //实付金额
      merchantNo: '', //商户号
      orderNo: '', //订单id
      zyName: '',
      derateType: '',
      currentDate: '', // 存储当前日期
      userMobile: '',
      userName: '',
      userId: ''
    };
  },
  mounted() {},
  created() {
    // this.toOrderConfirm();
  },

  computed: {},
  methods: {
    toOrderConfirm() {
      toOrderConfirm({ classIds: this.$route.query.classIds }).then(res => {
        console.log(res.data);
        if (res.data.data.code == '1') {
          this.calssInfo = res.data.data.data;
          this.paymentNum = this.calssInfo.totalPrice;

          getOrderId({ classIds: this.$route.query.classIds, derateType: '02' }).then(res => {
            this.merchantNo = res.data.data.merchantNo;
            this.orderNo = res.data.data.orderNo;
            this.userId = res.data.data.userId;
            this.userMobile = res.data.data.userMobile;
            this.userName = res.data.data.userName;
          });
          console.log(this.userName,'555');
          
        } else {
          this.$message(res.data.data.msg);
          this.$router.back();
        }
      });
    }
  }
};
</script>
<style lang="less" scoped>
/* //@import url(); 引入公共css类 */
#class1 {
  height: 550px;
}
* {
  font-family: Regular;
}
::v-deep {
  #widget_thirdapy_bosssoft .tabbox_bank {
    width: 71%;
  }
  #widget_thirdapy_bosssoft .order {
    width: 71%;
    padding: 20px 40px;
  }
}
</style>
